<script>
  import ListMain from '../../../../app/components/list/Main.vue'
  import ListHeader from '../../../../app/components/list/Header.vue'
  import ListEditButton from '../../../../app/components/list/EditButton.vue'
  import ListDeleteButton from '../../../../app/components/list/DeleteButton.vue'
  import bus from '@utils/bus'
  import {isEmpty} from 'lodash'
  import {mapGetters} from 'vuex'

  export default {
    components: {ListMain, ListHeader, ListEditButton, ListDeleteButton},
    data () {
      return {
        isLoadingData: true,
        filters: {},
        dependencies: {}
      }
    },
    mounted () {
      bus.$emit('list-init', {domain: 'user'}, () => {
        this.isLoadingData = false
      })
    },
    computed: {
      ...mapGetters(['listStore'])
    },
    methods: {
      onFilter () {
        const searchData = {}
        if (!isEmpty(this.filters.nome)) {
          searchData.name = {
            'ilike': '%' + this.filters.nome + '%'
          }
        }
        bus.$emit('list-filter', this.filters, searchData)
      },
      onFilterClean () {
        this.filters = {}
        bus.$emit('list-filter-clean', this.filters)
      },
      onDestroy (item) {
        bus.$emit('list-destroy-item', item)
      }
    },
    beforeMount () {
      this.listStore.listData = []
    }
  }
</script>

<template>
    <div>

        <ListHeader title="Usuários" store-route-name="user.store"/>

        <ListMain>

            <div slot="filters">

                <el-card class="el-card__search_list box-card">
                    <div slot="header">
                        <span>Filtrar Listagem</span>
                        <div>
                            <el-button type="primary" @click="onFilter">Pesquisar</el-button>
                            <el-button type="default" @click="onFilterClean">Limpar</el-button>
                        </div>
                    </div>
                    <el-form :inline="true" :model="filters" class="demo-form-inline">
                        <el-form-item label="Nome">
                            <el-input v-model="filters.nome"
                                      placeholder="Filtrar por nome"
                                      @keydown.enter.native.prevent="onFilter"/>
                        </el-form-item>
                    </el-form>
                </el-card>

            </div>

            <div slot="list" v-if="!isLoadingData">

                <h2>Lista de Usuários</h2>
                <table class="custom-table-list">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Matrícula</th>
                        <th>Nome</th>
                        <th class="btn-actions">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listStore.listData">
                        <td>{{item.id}}</td>
                        <td>{{item.ref_pessoa}}</td>
                        <td>{{item.pessoa.nome}}</td>
                        <td>
                            <div class="btn-actions">
                                <ListEditButton route-name="user.update" :item="item" domain="user"/>
                                <ListDeleteButton :item="item" domain="user"/>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </div>

        </ListMain>
    </div>
</template>



// WEBPACK FOOTER //
// List.vue?1c831a16